"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LoginWidgetState_1 = require("./LoginWidgetState");
/** Platform UI Components */
var Link_1 = require("@idp/ui-components/components/atoms/Link");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
// import { LoginWidgetCms } from './LoginWidget.cms';
/** Stylesheets */
var icons = require("../../../styles/att-icon-login.scss");
var globalStyles = require("../../../styles/att-global.scss");
var appStyles = require("../../../styles/login-widget.scss");
var styles = require("./LoginWidget.scss");
/** LOB Components */
var IconHeading_1 = require("../../common/IconHeading/IconHeading");
var Logo_1 = require("../../common/Logo/Logo");
var SkipAuthentication_1 = require("../../common/SkipAuthentication/SkipAuthentication");
var StandardView_1 = require("./StandardView/StandardView");
var SavedIdView_1 = require("./SavedIdView/SavedIdView");
var SavedUserIdHandler_1 = require("../../common/SaveUserID/SavedUserIdHandler");
var StateProvider_1 = require("../../../api/StateProvider");
var ReportingService_1 = require("../../../api/ReportingService");
var LoginApi_1 = require("../../../api/LoginApi");
var event_bus_1 = require("@idp/event-bus");
var UnauthenticatedPaymentsLink_1 = require("../../common/UnauthenticatedPaymentsLink/UnauthenticatedPaymentsLink");
var LoginWidget = /** @class */ (function (_super) {
    __extends(LoginWidget, _super);
    // private LoginWidgetCmsData: LoginWidgetCms;
    function LoginWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.tGuardMultiLoginStage = 'https://cgatemas.stage.att.com'
            + '/commonLogin/igate_wam/multiLogin.do';
        _this.tGuardTokenServiceStage = 'https://cgate.stage.att.com/TokenService'
            + '/nxsATS/WATokenService?appID={appId}&returnURL={returnUrl}';
        _this.tGuardMultiLoginProd = 'https://cprodmasx.att.com'
            + '/commonLogin/igate_wam/multiLogin.do';
        _this.tGuardTokenServiceProd = 'https://cprodx.att.com/TokenService'
            + '/nxsATS/WATokenService?appID={appId}&returnURL={returnUrl}';
        _this.forgotIDStageUrl = 'https://dssqa8-m.stage.att.com/my/#/forgotLoginLanding'
            + '?origination_point=idplgn&Flow_Indicator=FID';
        _this.forgotIDProdUrl = 'https://m.att.com/my/#/forgotLoginLanding'
            + '?origination_point=idplgn&Flow_Indicator=FID';
        _this.forgotPasswordStageUrl = 'https://dssqa8-m.stage.att.com/my/#/forgotLoginLanding'
            + '?origination_point=idplgn&Flow_Indicator=FPWD';
        _this.forgotPasswordProdUrl = 'https://m.att.com/my/#/forgotLoginLanding'
            + '?origination_point=idplgn&Flow_Indicator=FPWD';
        _this.RegistartionStageUrl = 'https://dssqa1-m.stage.att.com/my/#/welcome?origination_point=PLACEHOLDER_REGOP'
            + '&return_url=';
        _this.RegistartionProdUrl = 'https://m.att.com/my/#/welcome?origination_point=PLACEHOLDER_REGOP&return_url=';
        _this.idInvalidCharactersRegexp = /[^a-zA-Z0-9@ ._+-]+/g;
        // readonly idSimpleEmailPattern = /^.+@.+\..+$/g;
        _this.idSimpleEmailPattern = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        _this.validateConsecutiveSpecial = /[\-_\.][\-_\.]/;
        _this.idNumberPattern = /^\d+$/g;
        _this.commonLoginSubmit = 'Common_Login_Submit';
        _this.redirectUrl = 'https://www.att.com/shop/unified/authentication.html';
        _this.mvpView = true;
        _this.savedUserIdHandler = null;
        _this.getSavedUserIdsCallback = null;
        _this.saveUserIdCallback = null;
        _this.state = new LoginWidgetState_1.default();
        _this.api = new LoginApi_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.initializeEvents();
        _this.checkForSavedUserId = _this.checkForSavedUserId.bind(_this);
        _this.analyticsLoginPageLoad = _this.analyticsLoginPageLoad.bind(_this);
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        if (_this.props.data.saveUserIdHandler) {
            _this.savedUserIdHandler = _this.props.data.saveUserIdHandler;
        }
        else {
            _this.savedUserIdHandler = new SavedUserIdHandler_1.SavedUserIdColamCtn();
        }
        _this.showStandardView = _this.showStandardView.bind(_this);
        return _this;
    }
    LoginWidget.prototype.componentDidMount = function () {
        this.checkForSavedUserId();
        this.setupLoginWidgetEventListeners();
        if (this.props.options !== null &&
            this.props.options !== undefined &&
            this.props.options.pageLoadEvent !== null &&
            this.props.options.pageLoadEvent !== undefined &&
            this.props.options.pageLoadEvent) {
            this.analyticsLoginPageLoad();
        }
    };
    LoginWidget.prototype.preventDefault = function () {
        // Prevent the default from being triggered for the
        // form element
        event.preventDefault();
    };
    LoginWidget.prototype.analyticsLoginPageLoad = function () {
        this.reportingService
            .analyticsLoginPageLoad('isLoginPageLoadedAlready', ReportingService_1.PageUrls.LOGIN_PAGE, ReportingService_1.PageName.LOGIN_PAGE);
    };
    LoginWidget.prototype.initializeEvents = function () {
        var _this = this;
        // this.LoginWidgetCmsData = CMS.get(new LoginWidgetCms(), 'LoginWidget').content;
        this.LoginWidgetCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        this.linkRegisterEvents = {
            onClick: function () {
                _this.analyticsLoginPageLoad();
                _this.getRegistrationUrl();
            },
        };
        this.linkForgotPasswordEvents = {
            onClick: function () {
                _this.analyticsLoginPageLoad();
                var forgotPasswordUrl = '';
                var url = document.location.href;
                if (url.indexOf('stage.att.com') > -1 ||
                    url.indexOf('dev.att.com') > -1) {
                    forgotPasswordUrl = _this.forgotPasswordStageUrl + '&Return_URL=' + _this.getReturnUrl();
                }
                else {
                    forgotPasswordUrl = _this.forgotPasswordProdUrl + '&Return_URL=' + _this.getReturnUrl();
                }
                _this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.FORGOT_PASSWORD, forgotPasswordUrl);
                window.location.href = forgotPasswordUrl;
            },
        };
        this.linkForgotUserIdEvents = {
            onClick: function () {
                _this.analyticsLoginPageLoad();
                var forgotIDUrl = '';
                var url = document.location.href;
                if (url.indexOf('stage.att.com') > -1 ||
                    url.indexOf('dev.att.com') > -1) {
                    forgotIDUrl = _this.forgotIDStageUrl + '&Return_URL=' + _this.getReturnUrl();
                }
                else {
                    forgotIDUrl = _this.forgotIDProdUrl + '&Return_URL=' + _this.getReturnUrl();
                }
                _this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.FORGOT_ID, forgotIDUrl);
                window.location.href = forgotIDUrl;
                // console.log( 'forgotId' );
            },
        };
    };
    LoginWidget.prototype.getReturnUrl = function () {
        if (this.props.data && this.props.data.returnUrl) {
            return this.props.data.returnUrl;
        }
        else if (this.props.data && this.props.data.loginUrl) {
            return this.props.data.loginUrl;
        }
        else {
            var url = document.location.href +
                (document.location.href.indexOf('?') === -1 ? '?' : '&') +
                'authenticated=true';
            // return 'https://www.att.com/shop/unified/authentication.html';
        }
    };
    /*
    arrayRemove(array: string[], value: string) {
        return array.filter((el) => el !== value);
    }*/
    LoginWidget.prototype.getLoginUrl = function () {
        if (this.props.data && this.props.data.loginUrl) {
            return this.props.data.loginUrl;
        }
        else {
            return document.location.href;
        }
    };
    LoginWidget.prototype.getRegistrationUrl = function () {
        var base = null;
        if (this.props.data && this.props.data.registrationUrl) {
            base = this.props.data.registrationUrl + '&return_url=' + this.getReturnUrl();
        }
        else {
            var url = document.location.href;
            if (url.indexOf('stage.att.com') > -1 ||
                url.indexOf('dev.att.com') > -1) {
                base = this.RegistartionStageUrl + this.getReturnUrl();
            }
            else {
                base = this.RegistartionProdUrl + this.getReturnUrl();
            }
        }
        var op = this.props.options.registrationOriginationPoint || 'idmlgn';
        base = base.replace('PLACEHOLDER_REGOP', op);
        var sep = base.indexOf('?') === -1 ? '?' : '&';
        // If we don't have a return url - append both
        if (base.indexOf('return_url') === -1 &&
            base.indexOf('Return_URL') === -1) {
            base = base + sep + 'return_url=' +
                encodeURIComponent(this.getReturnUrl());
            base = base + '&' + 'cancel_url=' +
                encodeURIComponent(this.getLoginUrl());
        }
        this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.REGISTER, base);
        console.log("Registration OP: " + op + "; URL: " + base + "; ");
        window.location.href = base;
    };
    LoginWidget.prototype.notBlankCheck = function (parameter) {
        if (parameter !== '' && parameter != null
            && parameter !== undefined) {
            return true;
        }
        else {
            return false;
        }
    };
    LoginWidget.prototype.render = function () {
        if (this.props.data.loginUrl !== ''
            && this.props.data.loginUrl != null
            && this.props.data.loginUrl !== undefined) {
            this.loginUrl = this.props.data.loginUrl;
        }
        else {
            this.loginUrl = 'https://www.att.com/shop/unified/authentication.html';
        }
        console.log('LoginWidget - loginUrl ' + this.loginUrl);
        return (React.createElement("div", { className: [styles.loginWidgetWrapper].join(' ') },
            this.props.options && !this.props.options.suppressHeader &&
                React.createElement("section", { "data-test-id": "LoginWidget_Heading" },
                    React.createElement(IconHeading_1.default, { data: {
                            title: this.LoginWidgetCmsData.common.iconHeadingTitle,
                        }, options: {
                            accessibilityText: this.LoginWidgetCmsData.common.iconHeadingAccessibilityText,
                            iconClassName: icons.attIconLoginAccountAccess,
                        }, testId: 'LoginWidget_Icon_Heading' })),
            React.createElement("section", { "data-test-id": "LoginWidget" },
                React.createElement("div", null,
                    React.createElement("div", { className: [globalStyles.textCenter].join(' ') },
                        React.createElement(Logo_1.default, { options: {
                                accessibilityText: this.LoginWidgetCmsData.loginWidget.logoAccessibilityText,
                                iconClassName: icons.attIconLoginMyattLogo,
                            }, testId: 'LoginWidget_Logo' })),
                    this.state.savedUserIDExists &&
                        React.createElement(SavedIdView_1.default, { data: {
                                loginUrl: this.getLoginUrl(),
                                mvpView: this.props.data.mvpView,
                                returnUrl: this.getReturnUrl(),
                                saveUserIDList: this.state.saveUserIDList,
                                savedUserIdHandler: this.savedUserIdHandler,
                            }, options: {} }),
                    !this.state.savedUserIDExists &&
                        React.createElement(StandardView_1.default, { data: {
                                loginUrl: this.getLoginUrl(),
                                mvpView: this.props.data.mvpView,
                                returnUrl: this.getReturnUrl(),
                            }, options: {
                                suppressSavedId: this.props.options.suppressSavedId,
                                suppressUserIdPopupLinks: this.props.options.suppressUserIdPopupLinks,
                            } }),
                    this.forgotandRegistration())),
            this.props.options && !this.props.options.suppressSkipAuthLink &&
                React.createElement("section", { "data-test-id": "LoginWidget_SkipAuth" },
                    React.createElement(SkipAuthentication_1.default, { data: {
                            content: this.LoginWidgetCmsData.common.skipAuthLinkText,
                            loginUrl: this.loginUrl,
                        }, options: {
                            className: styles.loginWidgetScenario,
                        } })),
            this.props.options && this.props.options.showUnauthenticatedPayments &&
                React.createElement(UnauthenticatedPaymentsLink_1.default, { data: { loginUrl: this.loginUrl } })));
    };
    LoginWidget.prototype.checkForSavedUserId = function () {
        if (this.savedUserIdHandler !== null) {
            var ids = this.savedUserIdHandler.getSavedUserIds();
            console.log('SAVEDIDs', ids);
            if (ids !== null && ids.length > 0) {
                this.setState({ saveUserIDList: ids, savedUserIDExists: true });
            }
        }
    };
    LoginWidget.prototype.forgotandRegistration = function () {
        return (React.createElement("div", { className: [appStyles.forgotUidPwdSection].join(' ') },
            React.createElement("div", { className: [globalStyles.formRowMd, globalStyles.textCenter].join(' ') },
                React.createElement("span", null,
                    this.LoginWidgetCmsData.loginWidget.forgotUidPwdText1,
                    " "),
                React.createElement(Link_1.default, { data: {
                        content: this.LoginWidgetCmsData.loginWidget.forgotUidPwdLink1,
                    }, events: this.linkForgotUserIdEvents, testId: 'LoginWidget_Link_Forgot_UserID' }),
                React.createElement("span", null,
                    " ",
                    this.LoginWidgetCmsData.loginWidget.forgotUidPwdText2,
                    " "),
                React.createElement(Link_1.default, { data: {
                        content: this.LoginWidgetCmsData.loginWidget.forgotUidPwdLink2,
                    }, events: this.linkForgotPasswordEvents, testId: 'LoginWidget_Link_Forgot_Password' })),
            this.props.options && !this.props.options.suppressCreateOneLink &&
                React.createElement("div", { className: [globalStyles.textCenter].join(' ') },
                    React.createElement("span", null,
                        this.LoginWidgetCmsData.loginWidget.forgotUidPwdText3,
                        " "),
                    React.createElement(Link_1.default, { data: {
                            content: this.LoginWidgetCmsData.loginWidget.forgotUidPwdLink3,
                        }, events: this.linkRegisterEvents, testId: 'LoginWidget_Link_Create_UserID' }))));
    };
    LoginWidget.prototype.showStandardView = function () {
        this.setState({
            savedUserIDExists: false,
        });
    };
    LoginWidget.prototype.setupLoginWidgetEventListeners = function () {
        var showStandardViewListener = {
            eventHandler: this.showStandardView,
            observerId: event_bus_1.ICCEventBusManager.getUUID(),
            serviceName: SavedIdView_1.default.displayStandardViewEvent,
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(showStandardViewListener);
    };
    LoginWidget.prototype.componentWillUnmount = function () {
        event_bus_1.ICCEventBusManager.getInstance().deregisterObserver(event_bus_1.ICCEventBusManager.getUUID());
    };
    return LoginWidget;
}(React.Component));
exports.default = LoginWidget;
//# sourceMappingURL=LoginWidget.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/LoginWidget.js
// module id = 577
// module chunks = 8